import { PlantsEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('rm_antibiotics_info')
export class RmAntiBioticsTest {
    @PrimaryGeneratedColumn('increment', { name: 'infoId' })
    infoId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'grn_id'
    })
    grnId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'grn_item_id'
    })
    grnItemId: number;

    @Column({
        type: 'int',
        nullable: true,
        // default: 0,
        name: 'plant_id'
    })
    plantId: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'product_id'
    })
    productId: number;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "product_code"
    })
    productCode: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "lot_number"
    })
    lotNumber: string;


    @Column({
        type: 'int',
        nullable: true,
        // default: 0,
        name: 'deheading_center'
    }) 
    deHeadingCenter: number;

    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "sample_details"
    })
    sampleDetails: string;


    @Column("int", {
        nullable: true,
        name: "count"
    })
    count: number;

    @Column("int", {
        nullable: true,
        name: "no_of_boxes"
    })
    noOfBoxes: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'c_a_p_l'
    })
    CAPL: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'c_a_p'
    })
    CAP: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'a_o_z_l'
    })
    AOZL: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'a_o_z'
    })
    AOZ: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'a_m_o_z_l'
    })
    AMOZL: number;


    @Column({
        type: 'int',
        nullable: true,
        name: 'a_m_o_z'
    })
    AMOZ: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 's_e_m'
    })
    SEM: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'a_h_d'
    })
    AHD: number;

    @Column('varchar', {
        nullable: true,
        length: 30,
        name: 'remarks'
    })
    remarks: string;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;


    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
}